import React from 'react';

import { DashboardContentLayout } from '@portals/framework';

import { PurchasedProductsList } from './PurchasedProductsList';

export const PurchasedProducts = () => {
  return (
    <DashboardContentLayout
      pageTitle="Purchased Products"
      bg="gray.0"
      breadcrumbs={[
        {
          label: 'Products',
          to: '/products',
        },
        {
          label: 'Purchased Products',
        },
      ]}
    >
      <PurchasedProductsList />
    </DashboardContentLayout>
  );
};
